import { render, staticRenderFns } from "./DayOfRareDiseases.vue?vue&type=template&id=17c33897&scoped=true"
import script from "./DayOfRareDiseases.vue?vue&type=script&lang=js"
export * from "./DayOfRareDiseases.vue?vue&type=script&lang=js"
import style0 from "./DayOfRareDiseases.vue?vue&type=style&index=0&id=17c33897&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c33897",
  null
  
)

export default component.exports